module.exports = __webpack_public_path__ + "media/images/donations/master-e83fb4c24a56f68912d3d2a9d3ebbd3a.png";